module.exports = __webpack_public_path__ + "img/gear-E_72x72.6de990fa.png";